import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import FontAwesome icons
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { registerAdmin } from "../utils/Api/ApiCalls";
import { useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import Swal from "sweetalert2";
import ArgoneLogo from "../logo.svg";

const UserRegistration = () => {
  const Navigate = useNavigate();
  const schema = yup.object().shape({
    fullname: yup.string().required("Fullname is required"),
    email: yup.string().email().required("Email is required"),
    password: yup.string().required("Password is required"),
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State to manage password visibility

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const createAdmin = handleSubmit(async (data) => {
    setLoading(true);
    try {
      const res = await registerAdmin(data);
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: "Registration Successful",
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        Navigate("/admin-login");
      });
      reset();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "An error occurred",
        timer: 3000,
        showConfirmButton: false,
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  });

  return (
    <section className="content-main mt-80 pb-0">
      <div className="card mx-auto card-login">
        <div className="card-body">
          <p>
            <img src={ArgoneLogo} alt="Argone-logo" />
          </p>
          <h4 className="card-title mb-4">Create an Account</h4>
          <form onSubmit={createAdmin}>
            <div className="mb-3">
              <label className="form-label">
                Fullname<span style={{ color: "red" }}>*</span>
              </label>
              <input
                {...register("fullname")}
                className="form-control"
                placeholder="Your fullname"
                type="text"
              />
              <p style={{ color: "red" }}>{errors?.fullname?.message}</p>
            </div>
            <div className="mb-3">
              <label className="form-label">
                Email<span style={{ color: "red" }}>*</span>
              </label>
              <input
                {...register("email")}
                className="form-control"
                placeholder="Your email"
                type="text"
              />
              <p style={{ color: "red" }}>{errors?.email?.message}</p>
            </div>
            <div className="mb-3">
              <label className="form-label">
                Create password<span style={{ color: "red" }}>*</span>
              </label>
              <div className="input-group">
                <input
                  {...register("password")}
                  className="form-control"
                  placeholder="Password"
                  type={showPassword ? "text" : "password"}
                />
                <span
                  className="input-group-text"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    cursor: "pointer",
                    border: "none",
                    backgroundColor: "#f4f5f9",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              <p style={{ color: "red" }}>{errors?.password?.message}</p>
            </div>
            <div className="mb-3">
              <p className="small text-center text-muted">
                By signing up, you confirm that you’ve read and accepted our
                User Notice and Privacy Policy.
              </p>
            </div>

            {!loading ? (
              <div className="mb-4">
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  Register
                </button>
              </div>
            ) : (
              <div className="mb-4">
                <button
                  disabled
                  type="submit"
                  className="btn btn-primary w-100"
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <div>Loading... </div>
                    <span>
                      <ClipLoader color="white" size={15} />
                    </span>
                  </div>
                </button>
              </div>
            )}
          </form>
          <p className="text-center mb-2">
            Already have an account? <a href="admin-login">Sign in now</a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default UserRegistration;
